export default __webpack_public_path__ + "static/pic1-1744e7d217710713b7499e8b48b1c57c.png";